import React from 'react';
import { Link } from 'react-router-dom';

const uploadModules = [
  {
    id: 'wolt',
    name: 'Wolt',
    description: 'Upload and reconcile Wolt delivery settlement reports.',
    path: '/wolt',
  },
  {
    id: 'foodora',
    name: 'Foodora',
    description: 'Upload Foodora delivery invoice files.',
    path: '/foodora-upload',
  },
];

const Dashboard = () => {
  return (
    <div className="max-w-3xl mx-auto px-6 py-10">
      <header className="mb-10">
        <h1 className="text-xl font-semibold text-black">Dashboard</h1>
        <p className="text-gray-400 text-sm mt-1 max-w-xl">
          Upload settlement and invoice files from your payment providers, then
          create vouchers in Tripletex.
        </p>
      </header>

      <section>
        <h2 className="text-[10px] font-semibold uppercase tracking-widest text-gray-400 mb-3">
          Upload Modules
        </h2>
        <div className="space-y-px border border-gray-200 rounded-md overflow-hidden">
          {uploadModules.map((m) => (
            <Link
              key={m.id}
              to={m.path}
              className="flex items-center justify-between px-5 py-4 bg-white hover:bg-gray-50 transition-colors group"
            >
              <div>
                <h3 className="text-sm font-medium text-black">
                  {m.name}
                </h3>
                <p className="text-xs text-gray-400 mt-0.5">{m.description}</p>
              </div>
              <svg className="w-4 h-4 text-gray-300 group-hover:text-black transition-colors shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
